import { getUserInfo } from "./authService";

export const getCountry = () => {
  const userInfo = getUserInfo();
  if (!userInfo || !userInfo.country) return {};
  console.info('userInfo.country P', userInfo.country)
  return userInfo.country;
};
